document.addEventListener('DOMContentLoaded', function () {
  var variantImages = {
    black: 'https://cdn.shopify.com/s/files/1/0782/4998/4348/files/black_variant_selector_image.jpg',
    white: 'https://cdn.shopify.com/s/files/1/0782/4998/4348/files/white_variant_selector_image.jpg'
  };

  function detectKeyFromText(text) {
    text = String(text || '').toLowerCase();

    if (text.includes('white') || text.includes('weiß') || text.includes('weiss') || text.includes('wht')) return 'white';
    if (text.includes('black') || text.includes('schwarz') || text.includes('blk') || text.includes('blck')) return 'black';

    return null;
  }

  function addVariantButtonImages() {
    var labels = document.querySelectorAll('.option-selector__btns .opt-label');

    labels.forEach(function (label) {
      if (label.querySelector('.new-variant-thumb')) return;

      var inputId = label.getAttribute('for');
      var input = inputId ? document.getElementById(inputId) : null;

      var text = [
        label.textContent || '',
        input ? input.value : ''
      ].join(' ');

      var key = detectKeyFromText(text);
      if (!key || !variantImages[key]) return;

      var textEl = label.querySelector('.opt-label__text');
      if (textEl) {
        textEl.style.display = 'none';
      }

      var thumb = document.createElement('span');
      thumb.className = 'new-variant-thumb';
      thumb.style.backgroundImage = 'url("' + variantImages[key] + '")';

      label.appendChild(thumb);
    });
  }

  addVariantButtonImages();

  // --- Variant gallery: variant-specific images via metafields ---
  var $gallery = $('.gallery[data-cluster-variant-gallery]');

  if ($gallery.length) {
    var $slideshow = $gallery.find('.product-slideshow');
    var $thumbnails = $gallery.find('.thumbnails');
    var $slidesStore = $gallery.find('.cluster-variant-slides-store');
    var $thumbsStore = $gallery.find('.cluster-variant-thumbs-store');
    var currentVariantId = String($gallery.data('cluster-current-variant'));

    function activateLazyImages($container) {
      $container.find('img[data-src]').each(function () {
        this.src = this.dataset.src;

        if (this.dataset.srcset) {
          this.srcset = this.dataset.srcset;
        }

        this.classList.add('loaded');
      });
    }

    function switchVariantGallery(variantId) {
      variantId = String(variantId);

      if (!variantId || variantId === currentVariantId) return;

      var $newSlides = $slidesStore.find('[data-cluster-variant-id="' + variantId + '"]');
      if (!$newSlides.length) return;

      currentVariantId = variantId;

      $slideshow.find('video').each(function () {
        this.pause();
      });

      var previousSlickSettings = null;

      if ($slideshow.hasClass('slick-initialized')) {
        previousSlickSettings = $.extend(true, {}, $slideshow.slick('getSlick').originalSettings);
        $slideshow.slick('unslick');
      }

      $slideshow.html($newSlides.html());
      activateLazyImages($slideshow);

      var reinitSlickSettings = previousSlickSettings || {
        adaptiveHeight: true,
        initialSlide: 0
      };

      reinitSlickSettings.initialSlide = 0;
      $slideshow.slick(reinitSlickSettings);

      var $newThumbs = $thumbsStore.find('[data-cluster-variant-id="' + variantId + '"]');

      if ($newThumbs.length) {
        $thumbnails.html($newThumbs.html());
        activateLazyImages($thumbnails);
      }
    }

    $gallery.on('variantImageSelected', function (e, data) {
      e.stopImmediatePropagation();

      if (data && data.id) {
        switchVariantGallery(data.id);
      }
    });

    $(window).on('cc-variant-updated', function (e, args) {
      if (args && args.variant && args.variant.id) {
        if ($slidesStore.find('[data-cluster-variant-id="' + args.variant.id + '"]').length) {
          switchVariantGallery(args.variant.id);
        }
      }
    });
  }

  function initPdpUpsellToggle(toggle) {
    if (toggle.dataset.pdpUpsellInitialized === 'true') return;

    var block = toggle.closest('.pdp-upsell-block');
    var formContainer = toggle.closest('.product-form');
    var purchaseForm = formContainer ? formContainer.querySelector('form.product-purchase-form') : null;
    var priceMapElement = block ? block.querySelector('[data-pdp-upsell-price-map]') : null;

    if (!block || !formContainer || !purchaseForm || !priceMapElement) return;

    var priceMap;

    try {
      priceMap = JSON.parse(priceMapElement.textContent);
    } catch (error) {
      return;
    }

    toggle.dataset.pdpUpsellInitialized = 'true';

    var errorElement = block.querySelector('[data-pdp-upsell-error]');
    var upsellVariantId = toggle.dataset.upsellVariantId;

    function getCurrentVariantId() {
      var variantSelector = purchaseForm.querySelector('[name="id"]');
      return variantSelector ? String(variantSelector.value || '') : '';
    }

    function applyUpsellPrice() {
      var currentVariantId = getCurrentVariantId();
      var combinedPrice = priceMap[currentVariantId];
      var priceElement = formContainer.querySelector('.cluster-pdp-price-1');

      if (!priceElement) return;

      var currentPriceElement = priceElement.querySelector('.current-price');
      var comparePriceElement = priceElement.querySelector('.was-price');
      var discountElement = priceElement.querySelector('.cluster-discount-amount');
      var isActive = toggle.getAttribute('aria-pressed') === 'true';

      if (isActive && combinedPrice) {
        if (!comparePriceElement && combinedPrice.compare && currentPriceElement) {
          comparePriceElement = document.createElement('span');
          comparePriceElement.className = 'was-price theme-money';
          comparePriceElement.dataset.pdpUpsellCreated = 'true';
          priceElement.insertBefore(comparePriceElement, currentPriceElement);
        } else if (comparePriceElement && comparePriceElement.dataset.pdpUpsellCreated === 'true' && !combinedPrice.compare) {
          comparePriceElement.remove();
          comparePriceElement = null;
        }

        if (!discountElement && combinedPrice.discount) {
          discountElement = document.createElement('span');
          discountElement.className = 'cluster-discount-amount';
          discountElement.dataset.pdpUpsellCreated = 'true';
          priceElement.appendChild(discountElement);
        } else if (discountElement && discountElement.dataset.pdpUpsellCreated === 'true' && !combinedPrice.discount) {
          discountElement.remove();
          discountElement = null;
        }
      }

      var variantPriceChanged = priceElement.dataset.pdpUpsellBaseVariantId !== currentVariantId;

      if (currentPriceElement && (variantPriceChanged || !currentPriceElement.dataset.pdpUpsellBaseText)) {
        currentPriceElement.dataset.pdpUpsellBaseText = currentPriceElement.textContent;
      }

      if (
        comparePriceElement &&
        comparePriceElement.dataset.pdpUpsellCreated !== 'true' &&
        (variantPriceChanged || !comparePriceElement.dataset.pdpUpsellBaseText)
      ) {
        comparePriceElement.dataset.pdpUpsellBaseText = comparePriceElement.textContent;
      }

      if (
        discountElement &&
        discountElement.dataset.pdpUpsellCreated !== 'true' &&
        (variantPriceChanged || !discountElement.dataset.pdpUpsellBaseText)
      ) {
        discountElement.dataset.pdpUpsellBaseText = discountElement.textContent;
      }

      priceElement.dataset.pdpUpsellBaseVariantId = currentVariantId;

      if (isActive && combinedPrice) {
        if (currentPriceElement) {
          currentPriceElement.textContent = combinedPrice.current;
        }

        if (comparePriceElement && combinedPrice.compare) {
          comparePriceElement.textContent = combinedPrice.compare;
        }

        if (discountElement && combinedPrice.discount) {
          discountElement.textContent = combinedPrice.discount;
        }
      } else {
        if (currentPriceElement && currentPriceElement.dataset.pdpUpsellBaseText) {
          currentPriceElement.textContent = currentPriceElement.dataset.pdpUpsellBaseText;
        }

        if (comparePriceElement && comparePriceElement.dataset.pdpUpsellCreated === 'true') {
          comparePriceElement.remove();
        } else if (comparePriceElement && comparePriceElement.dataset.pdpUpsellBaseText) {
          comparePriceElement.textContent = comparePriceElement.dataset.pdpUpsellBaseText;
        }

        if (discountElement && discountElement.dataset.pdpUpsellCreated === 'true') {
          discountElement.remove();
        } else if (discountElement && discountElement.dataset.pdpUpsellBaseText) {
          discountElement.textContent = discountElement.dataset.pdpUpsellBaseText;
        }
      }
    }

    function setUpsellActive(isActive) {
      toggle.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      applyUpsellPrice();
    }

    function showUpsellError(message) {
      if (!errorElement) return;

      errorElement.textContent = message;
      errorElement.hidden = false;
    }

    function clearUpsellError() {
      if (!errorElement) return;

      errorElement.textContent = '';
      errorElement.hidden = true;
    }

    function getCartErrorMessage(error) {
      if (!error) return 'The products could not be added to the cart.';
      if (typeof error.description === 'string') return error.description;
      if (typeof error.message === 'string') return error.message;
      return 'The products could not be added to the cart.';
    }

    toggle.addEventListener('click', function () {
      setUpsellActive(toggle.getAttribute('aria-pressed') !== 'true');
    });

    $(formContainer).on('variantChanged.pdpUpsell', function () {
      applyUpsellPrice();
    });

    purchaseForm.addEventListener('submit', function (event) {
      if (toggle.getAttribute('aria-pressed') !== 'true') return;

      if (window.theme && typeof window.theme.validateProductForm === 'function') {
        if (!window.theme.validateProductForm($(formContainer))) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      clearUpsellError();

      var formData = new FormData(purchaseForm);
      var mainVariantId = formData.get('id');
      var mainQuantity = parseInt(formData.get('quantity') || '1', 10);

      if (!mainVariantId || !upsellVariantId) {
        showUpsellError('Please select a product option before adding to cart.');
        return;
      }

      var mainItem = {
        id: Number(mainVariantId),
        quantity: Number.isNaN(mainQuantity) ? 1 : Math.max(1, mainQuantity)
      };
      var properties = {};

      formData.forEach(function (value, key) {
        var propertyMatch = key.match(/^properties\[(.*)\]$/);

        if (propertyMatch && value !== '') {
          properties[propertyMatch[1]] = value;
        }
      });

      if (Object.keys(properties).length) {
        mainItem.properties = properties;
      }

      var sellingPlan = formData.get('selling_plan');
      if (sellingPlan) {
        mainItem.selling_plan = Number(sellingPlan);
      }

      var submitButton = event.submitter || purchaseForm.querySelector('button[type="submit"]');
      if (submitButton) {
        submitButton.classList.add('btn--in-progress');
        submitButton.disabled = true;
      }

      var cartAddUrl = window.theme && window.theme.routes
        ? window.theme.routes.cart_add_url
        : '/cart/add.js';

      fetch(cartAddUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            mainItem,
            {
              id: Number(upsellVariantId),
              quantity: 1
            }
          ],
          sections: 'cart-drawer'
        })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw data;
            return data;
          });
        })
        .then(function (response) {
          if (window.theme && window.theme.settings && window.theme.settings.after_add_to_cart === 'no-js') {
            window.location.assign(window.theme.routes.cart_url);
            return;
          }

          if (window.theme && typeof window.theme.addedToCartHandler === 'function') {
            window.theme.addedToCartHandler.call($(purchaseForm), response);
          } else {
            document.documentElement.dispatchEvent(
              new CustomEvent('theme:cartchanged', {
                bubbles: true,
                cancelable: false,
                detail: { openDrawer: true }
              })
            );
          }
        })
        .catch(function (error) {
          showUpsellError(getCartErrorMessage(error));
        })
        .finally(function () {
          if (submitButton) {
            submitButton.classList.remove('btn--in-progress');
            submitButton.disabled = false;
          }
        });
    }, true);

    applyUpsellPrice();
  }

  function initPdpUpsellToggles(scope) {
    var toggles = scope.querySelectorAll('[data-pdp-upsell-toggle]');

    toggles.forEach(function (toggle) {
      initPdpUpsellToggle(toggle);
    });
  }

  initPdpUpsellToggles(document);

  document.addEventListener('shopify:section:load', function (event) {
    initPdpUpsellToggles(event.target);
  });
});
